import styled from "styled-components";

// Corporate Colors
const PRIMARY_COLOR = "#203b34"; // Dark green
const SECONDARY_COLOR = "#f9ae17"; // Golden yellow

export const LoginContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background: #ffffff;
  margin: 0;
  padding: 0;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const LeftSection = styled.div`
  flex: 1;
  background: linear-gradient(135deg, #1a3a32 0%, #2d5047 50%, #1f4540 100%);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 60px 40px;
  color: white;
  position: relative;
  overflow: hidden;

  /* Círculo 1 - Grande */
  &::before {
    content: "";
    position: absolute;
    top: 45%;
    right: 5%;
    width: 700px;
    height: 700px;
    border: 2px solid rgba(255, 255, 255, 0.06);
    border-radius: 50%;
    pointer-events: none;
    z-index: 0;
  }

  /* Círculo 2 - Mediano */
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    right: 12%;
    width: 500px;
    height: 500px;
    border: 1.5px solid rgba(255, 255, 255, 0.05);
    border-radius: 50%;
    pointer-events: none;
    z-index: 0;
  }

  > * {
    position: relative;
    z-index: 1;
  }

  @media (max-width: 768px) {
    padding: 40px 30px;
    min-height: 400px;
  }
`;

export const RightSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 60px 40px;
  background: #f8f9fa;
  position: relative;

  .language-selector {
    position: absolute;
    top: 30px;
    right: 40px;

    @media (max-width: 768px) {
      top: 20px;
      right: 20px;
    }

    .btn {
      background: ${PRIMARY_COLOR};
      color: white;
      border: none;
      padding: 8px 12px;
      border-radius: 20px;
      font-size: 0.9rem;

      &:hover {
        background: ${SECONDARY_COLOR};
        color: ${PRIMARY_COLOR};
      }
    }

    .dropdown-menu {
      background: ${PRIMARY_COLOR};
      border: none;
      border-radius: 8px;
      min-width: 180px;

      .dropdown-item {
        color: white;
        padding: 10px 15px;

        &:hover {
          background: ${SECONDARY_COLOR};
          color: ${PRIMARY_COLOR};
        }
      }
    }
  }

  @media (max-width: 768px) {
    padding: 40px 30px;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 40px;
`;

export const LogoBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  background: ${SECONDARY_COLOR};
  color: ${PRIMARY_COLOR};
  padding: 12px 20px;
  border-radius: 50px;
  font-weight: 700;
  font-size: 0.95rem;
  width: fit-content;
  max-width: 280px;

  span {
    display: flex;
    align-items: center;
  }

  .badge-text {
    letter-spacing: 0.5px;
    line-height: 1.4;
    white-space: normal;
  }
`;

export const MainTitle = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  margin: 30px 0 20px 0;
  line-height: 1.2;
  text-transform: capitalize;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const SubtitleText = styled.p`
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 40px;
  line-height: 1.6;
  max-width: 400px;
`;

export const FeatureList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin: 40px 0;
`;

export const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 1rem;
  font-weight: 500;

  .check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    background: ${SECONDARY_COLOR};
    color: ${PRIMARY_COLOR};
    border-radius: 50%;
    font-weight: 700;
    font-size: 1.1rem;
  }

  .feature-text {
    color: rgba(255, 255, 255, 0.95);
  }
`;

export const RightContent = styled.div`
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .welcome-title {
    font-size: 2.5rem;
    font-weight: 700;
    color: ${PRIMARY_COLOR};
    margin-bottom: 10px;
    text-align: center;
  }

  .welcome-subtitle {
    font-size: 1rem;
    color: #666;
    margin-bottom: 40px;
    text-align: center;
  }

  @media (max-width: 768px) {
    .welcome-title {
      font-size: 2rem;
    }
  }
`;

export const CardBox = styled.div`
  width: 100%;
  background: white;
  border-radius: 16px;
  padding: 40px 30px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  .help-text {
    font-size: 0.85rem;
    color: #999;
    margin: 0;
    padding-top: 8px;
  }
`;

export const CardIcon = styled.div`
  font-size: 3.5rem;
  margin-bottom: 20px;
`;

export const CardTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  color: ${PRIMARY_COLOR};
  margin-bottom: 12px;
`;

export const CardDescription = styled.p`
  font-size: 0.95rem;
  color: #666;
  margin-bottom: 30px;
  line-height: 1.6;
`;

export const LoginButton = styled.button`
  width: 100%;
  padding: 14px 30px;
  background: ${SECONDARY_COLOR};
  color: ${PRIMARY_COLOR};
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  margin-bottom: 20px;
  transition: all 0.3s ease;

  &:hover {
    background: #f0a316;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(249, 174, 23, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const SecurityBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  color: #666;
  padding: 12px 16px;
  background: #f0f0f0;
  border-radius: 8px;
  margin-bottom: 16px;

  .icon {
    font-size: 1rem;
  }
`;

export const LanguageContainer = styled.div`
  margin: 0;
`;

export const Footer = styled.footer`
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.7);
  margin-top: 60px;
  text-align: center;

  @media (max-width: 768px) {
    margin-top: 40px;
  }
`;

// Legacy styles for compatibility
export const Container = styled.div`
  min-height: calc(100vh - 120px);
  background: transparent;
`;

export const Title = styled.span`
  font-size: 2rem;
  font-weight: 600;
  color: #fff;
  text-transform: uppercase;
`;
